export default {
  SET_SEARCH_TEXT(state, value) {
    state.searchText = value;
  },
};
